import {Employee, useApiCall, useApiEndpoint} from "@jane/lib/src/api"
import { Card } from "@jane/lib/src/components/Card";
import React from "react"
import {config} from "../config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck, faCircleXmark} from "@fortawesome/free-solid-svg-icons";



export const MobileCard: React.FC<{employee: Employee}> = props => {
  const { employees } = useApiCall(config)
  const {resource: mobileDeployments} = useApiEndpoint(() => employees.getMobileVersionDeployments(props.employee.sub), true)
    return <Card title={"App info"} id={"app_info"}>
      {mobileDeployments && mobileDeployments?.length > 0 ?
        <div className="flex flex-1 w-full overflow-x-auto">
          <table className="min-w-full table-auto border border-slate-200">
            <thead className="bg-brand-primary text-brand-on-primary">
            <tr>
              <th className="px-4 py-2 text-left border-b border-slate-200">OS</th>
              <th className="px-4 py-2 text-left border-b border-slate-200">OS versie</th>
              <th className="px-4 py-2 text-left border-b border-slate-200">App versie</th>
              <th className="px-4 py-2 text-left border-b border-slate-200">Supported</th>
              <th className="px-4 py-2 text-left border-b border-slate-200">Laatst ingelogd</th>
            </tr>
            </thead>
            <tbody className="bg-brand-surface text-brand-on-primary-container text-center">
            {mobileDeployments.map((deployment) => {
              return <tr>
                <td className="px-4 py-2 border-b border-slate-100">{deployment.mobile_version_deployment?.os}</td>
                <td className="px-4 py-2 border-b border-slate-100">{deployment.mobile_version_deployment?.os_version}</td>
                <td className="px-4 py-2 border-b border-slate-100">{deployment.mobile_version_deployment?.mobile_version?.version}</td>
                <td className="px-4 py-2 border-b border-slate-100"><FontAwesomeIcon icon={deployment.mobile_version_deployment?.mobile_version?.is_supported ? faCircleCheck : faCircleXmark} /></td>
                <td className="px-4 py-2 border-b border-slate-100">
                  {deployment.mobile_version_deployment?.updated_at ? new Date(deployment.mobile_version_deployment.updated_at).toLocaleString('nl-NL', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                    }) : '-'}
                </td>

              </tr>
            })}
            </tbody>
          </table>
        </div>
        :
        <div>
          <p>Deze gebruiker heeft nog geen inlog entry</p>
        </div>
      }
    </Card>
}
